import CommentService from '@/services/CommentService';

const localState = () => ({
});

const mutations = {
}

const actions = {
  async newComment({}, data) {
    return await CommentService.newComment(data);
  },
  async removeComment({}, key) {
    return await CommentService.removeComment(key);
  },
  async updateComment({}, data) {
    return await CommentService.updateComment(data);
  },
  async getCommentList({}, data) {
    return await CommentService.getCommentList(data);
  }
}

export default {
  state: localState(),
  mutations,
  actions,
};
